import CarCard from './CarCard';
export default CarCard;
